<template>
  <div class="admin-room-container figma-property-page">
    <!-- Figma风格白色卡片容器 -->
    <div class="figma-white-card">
      <!-- 页面头部：标题 + 按钮 + 搜索 -->
      <div class="figma-page-header">
        <div class="figma-page-title">
          <span :class="['child-tab-title', { 'is-muted': activeChildTab === 'property' }]" @click="_openCommunityTab">{{ $t('committeeCommunityManage.pageTitle') }}</span>
          <template v-if="activeChildTab === 'property'">
            <img src="../../../assets/CodeBuddyAssets/616_18821/27.svg" class="child-tab-separator" />
            <span class="child-tab-title is-active">{{ $t('committeeCommunityManage.action.propertyManage') }}</span>
          </template>
        </div>
        <div class="figma-header-divider"></div>
        <!-- 第二行：按钮 + 搜索 -->
        <div v-if="activeChildTab === 'community'" class="figma-header-row">
          <!-- 操作按钮组 -->
          <div class="figma-btn-group">
            <el-button size="small" class="figma-btn-refresh" title="刷新" @click="_queryCommunityMethod">
              <img src="../../../assets/CodeBuddyAssets/616_12573/24.svg" class="btn-icon" />
            </el-button>
          </div>
          <!-- 搜索区域 -->
          <div class="figma-search-group">
            <el-input size="small" v-model="communityManageInfo.conditions.name"
              :placeholder="$t('committeeCommunityManage.search.keywordPlaceholder')" class="figma-search-input" clearable
              @keyup.enter.native="_queryCommunityMethod" />
            <el-select size="small" v-model="communityManageInfo.conditions.statusCd"
              :placeholder="$t('committeeCommunityManage.search.statePlaceholder')" class="figma-search-input" clearable
              @change="_queryCommunityMethod">
              <el-option :label="$t('committeeCommunityManage.search.stateNormal')" value="0" />
              <el-option :label="$t('committeeCommunityManage.search.stateDisabled')" value="1" />
            </el-select>
            <el-button size="small" class="figma-btn-search" @click="_queryCommunityMethod">
              <img src="../../../assets/CodeBuddyAssets/616_12573/29.svg" class="btn-icon" />
              <span>{{ $t('common.search') }}</span>
            </el-button>
          </div>
        </div>
      </div>

      <template v-if="activeChildTab === 'community'">
      <!-- 表格区域 -->
      <div class="figma-table-section">
        <el-table :data="communityManageInfo.communitys" style="width: 100%" :header-cell-style="headerCellStyle" :cell-style="cellStyle">
          <el-table-column prop="communityId" :label="$t('committeeCommunityManage.table.communityId')" min-width="190" show-overflow-tooltip class-name="community-id-column">
            <template slot-scope="scope">{{ scope.row.communityId || '-' }}</template>
          </el-table-column>
          <el-table-column prop="name" :label="$t('committeeCommunityManage.table.name')" min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.name || '-' }}</template>
          </el-table-column>
          <el-table-column prop="provName" :label="$t('committeeCommunityManage.table.province')" min-width="100" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.provName || '-' }}</template>
          </el-table-column>
          <el-table-column prop="cityName" :label="$t('committeeCommunityManage.table.cityName')" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">{{ getCityText(scope.row) }}</template>
          </el-table-column>
          <el-table-column prop="adminName" :label="$t('committeeCommunityManage.table.storeName')" min-width="140" show-overflow-tooltip>
            <template slot-scope="scope">{{ getAdminName(scope.row) }}</template>
          </el-table-column>
          
          <el-table-column prop="voteReminder" :label="$t('committeeCommunityManage.table.voteReminder')" min-width="90">
            <template slot-scope="scope">
              <span :class="['status-tag', getVoteReminderClass(scope.row)]">{{ getVoteReminderName(scope.row) }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="statusCd" :label="$t('committeeCommunityManage.table.state')" min-width="90">
            <template slot-scope="scope">
              <span :class="['status-tag', getStateClass(scope.row)]">{{ getStateName(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.operation')" fixed="right" min-width="110">
            <template slot-scope="scope">
              <span class="action-links">
                <a class="action-link" @click="_goPropertyManage(scope.row)">{{ $t('committeeCommunityManage.action.propertyManage') }}</a>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="figma-pagination">
        <el-pagination
          :current-page="pagination.current"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pagination.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
      </template>
      <committee-room-list
        v-else
        class="community-room-child"
        :community-id="selectedCommunity ? selectedCommunity.communityId : ''"
        :embedded="true"
      />

      <!-- 组件 -->
      <add-community ref="addCommunity" @listData="_queryCommunityMethod" />
      <edit-community ref="editCommunity" @listData="_queryCommunityMethod" />
      <delete-community ref="deleteCommunity" @listData="_queryCommunityMethod" />
    </div>
  </div>
</template>

<script>
import { listCommunitysByOwnerCommittee } from '@/api/owner/ownerCommitteeManageApi'
import AddCommunity from '@/components/community/addCommunity'
import EditCommunity from '@/components/community/editCommunity'
import DeleteCommunity from '@/components/community/deleteCommunity'
import CommitteeRoomList from '@/views/committee/committeeRoomList.vue'
import { getAttrSpecList } from '@/api/dev/attrSpecApi'

export default {
  name: 'CommitteeCommunityManageList',
  components: {
    AddCommunity,
    EditCommunity,
    DeleteCommunity,
    CommitteeRoomList,
  },
  data() {
    return {
      communityManageInfo: {
        communitys: [],
        storeTypeCd: '',
        conditions: {
          name: '',
          cityCode: '',
          communityId: '',
          statusCd: ''
        },
        listColumns: []
      },
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      activeChildTab: 'community',
      selectedCommunity: null
    }
  },
  created() {
    this._initMethod()
  },
  methods: {
    async _initMethod() {
      await this._getColumns()
      this._listCommunitysByOwnerCommittee(this.pagination.current, this.pagination.size)
    },
    async _listCommunitysByOwnerCommittee(page, size) {
      try {
        const { communityId, ...conditions } = this.communityManageInfo.conditions
        const params = {
          ...conditions,
          page,
          row: size
        }
        const res = await listCommunitysByOwnerCommittee(params)
        this.communityManageInfo.total = res.total
        this.communityManageInfo.records = res.records
        this.communityManageInfo.communitys = res.data
        this.dealCommunityAttr(res.data)
        this.pagination.total = res.total
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    selectArea(area) {
      this.communityManageInfo.conditions.cityCode = area.selectArea
    },
    _openAddCommunityModal() {
      this.$refs.addCommunity.openModal()
    },
    _openEditCommunityModel(community) {
      this.$refs.editCommunity.openModal(community)
    },
    _openDeleteCommunityModel(community) {
      this.$refs.deleteCommunity.openModal(community)
    },
    _openCommunityTab() {
      this.activeChildTab = 'community'
    },
    _goPropertyManage(community) {
      this.selectedCommunity = community
      this.activeChildTab = 'property'
    },
    _queryCommunityMethod() {
      this.pagination.current = 1
      this._listCommunitysByOwnerCommittee(this.pagination.current, this.pagination.size)
    },
    _resetCommunityMethod() {
      this.communityManageInfo.conditions = {
        name: '',
        cityCode: '',
        communityId: '',
        statusCd: ''
      }
      this._listCommunitysByOwnerCommittee(this.pagination.current, this.pagination.size)
    },
    dealCommunityAttr(communitys) {
      communitys.forEach(item => {
        this._getColumnsValue(item)
      })
    },
    _getColumnsValue(community) {
      community.listValues = []
      if (!community.communityAttrDtos || community.communityAttrDtos.length < 1) {
        this.communityManageInfo.listColumns.forEach(() => {
          community.listValues.push('')
        })
        return
      }
      this.communityManageInfo.listColumns.forEach(column => {
        let tmpValue = ''
        community.communityAttrDtos.forEach(attrItem => {
          if (column.specCd === attrItem.specCd) {
            tmpValue = attrItem.value
          }
        })
        community.listValues.push(tmpValue)
      })
    },
    async _getColumns() {
      const { data } = await getAttrSpecList({
        page: 1,
        row: 100,
        tableName: 'building_community_attr'
      })
      this.communityManageInfo.listColumns = []
      data.forEach(item => {
        if (item.listShow === 'Y') {
          this.communityManageInfo.listColumns.push({
            specCd: item.specCd,
            specName: item.specName
          })
        }
      })
    },
    getCityText(row) {
      const city = row.cityName || ''
      const area = row.areaName || ''
      return city || area ? `${city}${area}` : '-'
    },
    getAdminName(row) {
      if (row.adminUsers && row.adminUsers.length > 0) {
        return row.adminUsers.map(u => u.adminUserName).join(', ') || '-'
      }
      return row.adminName || row.storeName || row.contactName || row.userName || '-'
    },
    getStatusCd(row) {
      const statusCd = row.statusCd !== undefined ? row.statusCd : row.status_cd
      if (statusCd !== undefined && statusCd !== null && statusCd !== '') {
        return String(statusCd)
      }
      if (row.state === '1200') {
        return '1'
      }
      if (row.state === '1100') {
        return '0'
      }
      return row.state !== undefined && row.state !== null ? String(row.state) : ''
    },
    getStateName(row) {
      const statusCd = this.getStatusCd(row)
      if (statusCd === '0') {
        return this.$t('committeeCommunityManage.search.stateNormal')
      }
      if (statusCd === '1') {
        return this.$t('committeeCommunityManage.search.stateDisabled')
      }
      return row.stateName || '-'
    },
    getStateClass(row) {
      const statusCd = this.getStatusCd(row)
      const map = { '0': 'status-occupied', '1': 'status-danger', '1100': 'status-occupied', '1200': 'status-danger' }
      return map[statusCd] || 'status-unsold'
    },
    getVoteReminderClass(row) {
      return this._isVoteReminderOn(row) ? 'status-occupied' : 'status-unsold'
    },
    getVoteReminderName(row) {
      return this._isVoteReminderOn(row) ? this.$t('committeeCommunityManage.voteReminder.on') : this.$t('committeeCommunityManage.voteReminder.off')
    },
    _isVoteReminderOn(row) {
      const val = row.voteReminder !== undefined ? row.voteReminder : (row.vote_reminder !== undefined ? row.vote_reminder : (row.Urgetickets !== undefined ? row.Urgetickets : null))
      if (val === null || val === undefined || val === '') return false
      return val === 'Y' || val === 'y' || val === true || val === 1 || val === 'true' || val === 'TRUE'
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this._listCommunitysByOwnerCommittee(this.pagination.current, val)
    },
    handleCurrentChange(val) {
      this.pagination.current = val
      this._listCommunitysByOwnerCommittee(val, this.pagination.size)
    },
    headerCellStyle() {
      return {
        background: '#EBF2FA',
        color: '#364153',
        fontSize: '14px',
        fontWeight: '500',
        fontFamily: 'PingFang SC',
        height: '50px'
      }
    },
    cellStyle({ row }) {
      const rowIndex = this.communityManageInfo.communitys.indexOf(row)
      if (rowIndex % 2 === 1) {
        return {
          background: '#F8FBFF',
          color: '#1D2129',
          fontSize: '14px',
          fontFamily: 'PingFang SC',
          height: '50px'
        }
      }
      return {
        background: 'white',
        color: '#1D2129',
        fontSize: '14px',
        fontFamily: 'PingFang SC',
        height: '50px'
      }
    }
  }
}
</script>

<style scoped>
.admin-room-container {
  height: calc(100vh - 92px);
  min-height: 0;
  background: #FFFFFF;
  padding: 0;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.figma-white-card {
  flex: 1;
  min-height: 0;
  background: #FFFFFF;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.figma-page-header {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 22px 24px 0;
}

.figma-page-title {
  width: 100%;
  color: #1D2129;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  font-family: 'PingFang SC', sans-serif;
  text-align: left;
  display: flex;
  align-items: center;
  gap: 12px;
}

.child-tab-title {
  color: #1D2129;
  cursor: default;
}

.child-tab-title.is-muted {
  color: #8C9BB4;
  cursor: pointer;
}

.child-tab-title.is-active {
  color: #1D2129;
}

.child-tab-separator {
  width: 16px;
  height: 16px;
}

.figma-header-divider {
  width: 100%;
  height: 1px;
  background: #EDF2FA;
  margin-top: 22px;
}

.figma-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 23px;
}

.figma-btn-group,
.figma-search-group {
  display: flex;
  align-items: center;
  gap: 12px;
}

.figma-search-group {
  margin-left: auto;
}

.figma-btn-add {
  width: 114px;
  height: 38px;
  border-radius: 10px !important;
  border: none !important;
  background: #0E76FF !important;
  color: #FFFFFF !important;
  font-size: 14px;
  font-weight: 500;
  font-family: Inter, 'PingFang SC', sans-serif;
  padding: 0 !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.figma-btn-add:hover {
  background: #0A6AE5 !important;
}

.figma-btn-refresh {
  width: 38px;
  height: 38px;
  border-radius: 10px !important;
  border: 1px solid #DCE6F5 !important;
  background: #FFFFFF !important;
  padding: 0 !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.figma-btn-refresh:hover {
  border-color: #0E76FF !important;
}

.btn-icon {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}

.figma-btn-refresh .btn-icon {
  width: 16px;
  height: 16px;
}

.figma-search-input {
  width: 256px;
  height: 38px;
}

.figma-search-input >>> .el-input__inner {
  height: 38px;
  border: none;
  outline: 1px solid #DCE6F5;
  outline-offset: -1px;
  border-radius: 10px;
  background: #FFFFFF;
  color: #1D2129;
  font-size: 14px;
  font-family: Inter, 'PingFang SC', sans-serif;
  padding: 0 16px;
}

.figma-search-input >>> .el-input__inner:focus {
  outline-color: #0E76FF;
}

.figma-search-input >>> .el-input__inner::placeholder {
  color: #8C9BB4;
}

.figma-btn-search {
  width: 84px;
  height: 38px;
  border-radius: 10px !important;
  border: none !important;
  outline: 1px solid #0E76FF !important;
  outline-offset: -1px;
  background: #FFFFFF !important;
  color: #0E76FF !important;
  font-size: 14px;
  font-weight: 500;
  font-family: Inter, 'PingFang SC', sans-serif;
  padding: 0 !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.figma-btn-search:hover {
  background: rgba(14, 118, 255, 0.08) !important;
}

.figma-table-section {
  flex: 1 1 auto;
  min-height: 0;
  padding: 24px 24px 0;
  overflow: auto;
}

.community-room-child {
  flex: 1;
  min-height: 0;
}

.figma-table-section >>> .el-table {
  border: none;
  border-radius: 0;
  overflow: hidden;
  color: #1D2129;
  font-family: 'PingFang SC', sans-serif;
}

.figma-table-section >>> .el-table__header th {
  background: #EBF2FA !important;
  border: none !important;
}

.figma-table-section >>> .el-table__body td {
  border: none !important;
  border-bottom: 1px solid #F0F0F0 !important;
}

.figma-table-section >>> .el-table__body tr:nth-child(even) td {
  background: #F8FBFF !important;
}

.figma-table-section >>> .el-table .cell {
  padding-left: 24px;
  padding-right: 24px;
  line-height: 22px;
  text-align: left;
}

.figma-table-section >>> .community-id-column .cell {
  white-space: nowrap;
}

.figma-table-section >>> .el-table::before {
  display: none;
}

.status-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 52px;
  height: 28px;
  padding: 0 12px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  box-sizing: border-box;
}

.status-occupied {
  background: rgba(33, 185, 86, 0.10);
  color: #21B956;
  outline: 1px solid #21B956;
  outline-offset: -1px;
}

.status-unsold {
  background: rgba(140, 155, 180, 0.10);
  color: #8C9BB4;
  outline: 1px solid #8C9BB4;
  outline-offset: -1px;
}

.status-danger {
  background: rgba(251, 44, 54, 0.10);
  color: #FB2C36;
  outline: 1px solid #FB2C36;
  outline-offset: -1px;
}

.status-warning {
  background: rgba(255, 153, 0, 0.10);
  color: #FF9900;
  outline: 1px solid #FF9900;
  outline-offset: -1px;
}

.action-links {
  display: inline-flex;
  align-items: center;
}

.action-link {
  color: #0E76FF;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
}

.action-link:hover {
  text-decoration: underline;
}

.figma-pagination {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 16px 24px;
  gap: 8px;
  border-top: none;
}

.figma-pagination >>> .el-pagination {
  display: flex;
  align-items: center;
  padding: 0;
  gap: 8px;
}

.figma-pagination >>> .el-pagination__total,
.figma-pagination >>> .el-pagination__jump {
  color: #1D2129;
  font-size: 14px;
  font-weight: 400;
  font-family: 'PingFang SC', sans-serif;
  margin: 0;
}

.figma-pagination >>> .el-pagination__sizes {
  margin: 0;
}

.figma-pagination >>> .el-pagination__sizes .el-input {
  width: 100px;
  margin: 0;
}

.figma-pagination >>> .el-pager li {
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 600;
  font-family: 'Nunito Sans', sans-serif;
}

.figma-pagination >>> .el-pager li.active {
  background: #E8F3FF;
  color: #0E76FF;
}

.figma-pagination >>> .el-pager li:hover {
  color: #0E76FF;
}

.figma-pagination >>> .btn-prev,
.figma-pagination >>> .btn-next {
  width: 32px;
  height: 32px;
  border-radius: 2px;
  padding: 0;
}

.figma-pagination >>> .el-pagination__sizes .el-input__inner,
.figma-pagination >>> .el-pagination__jump .el-input__inner {
  height: 32px;
  border: none;
  border-radius: 2px;
  background: #F2F3F5;
  color: #1D2129;
  font-size: 14px;
  font-weight: 400;
  font-family: 'PingFang SC', sans-serif;
}

@media (max-width: 1024px) {
  .admin-room-container {
    height: auto;
    min-height: calc(100vh - 92px);
  }
  .figma-header-row {
    align-items: flex-start;
    flex-direction: column;
    gap: 16px;
  }
  .figma-search-group {
    width: 100%;
    margin-left: 0;
  }
  .figma-search-input {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .figma-page-header,
  .figma-table-section,
  .figma-pagination {
    padding-left: 16px;
    padding-right: 16px;
  }
  .figma-pagination {
    flex-wrap: wrap;
  }
}
</style>
